import { NgModule } from '@angular/core';

import { PublicRoutingModule } from './public-routing.module';
import { LoginModule } from './login/login.module';
import { SharedModule } from '../shared/shared.module';
import { ConfirmAccountModule } from './confirm-account/confirm-account.module';
import { RecoveryModule } from './recovery/recovery.module';

@NgModule({
	declarations: [],
	imports: [
		SharedModule,
		PublicRoutingModule,
		LoginModule,
		ConfirmAccountModule,
		RecoveryModule
	]
})
export class PublicModule {}
